import { useEffect } from 'react';
import { useAtomValue } from 'jotai';

import { serverListPayloadAtom } from '../../job-explorer-server.atoms';
import { searchBarUrlParamsAtom } from '../../job-explorer-filters.atoms';
import { getMapRefAtom } from '../../job-explorer-map.atoms';

export const useMapRedirection = () => {
  const serverListPayload = useAtomValue(serverListPayloadAtom);
  const { isSearchBarUrlParamsAvailable, locationUrlParams, jobListUrlParams, mapFiltersURLParams } =
    useAtomValue(searchBarUrlParamsAtom);
  const mapRef = useAtomValue(getMapRefAtom);
  useEffect(() => {
    try {
      if (!isSearchBarUrlParamsAvailable) return;
      if (locationUrlParams?.value?.lat) {
        /* in case of locationUrlParams is exist from search bar */
        mapRef.current?.flyTo({
          duration: 1000,
          center: [locationUrlParams.value?.lng, locationUrlParams.value.lat],
          zoom: locationUrlParams.value?.['zoom'] ?? 5,
        });
      } else if (serverListPayload?.lon) {
        mapRef.current?.flyTo({
          duration: 1000,
          center: [serverListPayload?.lon, serverListPayload?.lat],
          zoom: serverListPayload?.['zoom'] ?? 10,
        });
      } else if (mapFiltersURLParams?.['latitude']) {
        /* in case of map params filter exists */
        mapRef.current?.flyTo({
          duration: 1000,
          center: [mapFiltersURLParams['longitude'], mapFiltersURLParams['latitude']],
          zoom: mapFiltersURLParams?.['zoom'] ?? 5,
        });
      } else if (jobListUrlParams?.['user_location_lon']) {
        mapRef.current?.flyTo({
          duration: 1000,
          center: [+jobListUrlParams?.user_location_lon, +jobListUrlParams?.user_location_lat],
          zoom: 7,
        });
      }
    } catch (error) {
      console.error('Error parsing search bar filter JSON:', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isSearchBarUrlParamsAvailable,
    jobListUrlParams,
    locationUrlParams?.value,
    mapFiltersURLParams,
    mapRef?.current,
    serverListPayload,
  ]);
};
